export enum ErrorContextActionTypes {
  SetError = 'errors/SET',
  ClearError = 'errors/CLEAR',
}

export type ErrorContextActions =
  | { type: ErrorContextActionTypes.SetError; payload: ErrorsProps }
  | { type: ErrorContextActionTypes.ClearError };

export type ErrorsProps = {
  error: any;
  count?: number;
  includeDetails?: boolean;
};

export type ErrorsProviderProps = { children: React.ReactNode };
